export { default } from './FormLabel';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/FormLabel/index.js
// module id = 328
// module chunks = 0